import naja from 'naja';
import netteForms from 'nette-forms';
import {debounce} from "@weseus/cms-core/assets/js/helpers";

naja.formsHandler.netteForms = netteForms;
window.Nette = netteForms;

// fix for number input, todo: remove after fix in nette-forms [https://github.com/nette/forms/issues/289]
// netteForms.getValue = (function (original) {
// 	return function (elem) {
// 		const value = original(elem);
// 		if (elem.type === 'number' && value !== null && value !== undefined && value !== '') {
// 			return parseInt(value);
// 		}
//
// 		return value;
// 	}
// })(netteForms.getValue)


// validation rules
netteForms.validators.filledInput = function(elem, arg, val) {
	const input = document.getElementById(arg);

	if (input === null || input.tagName !== 'INPUT') {
		return false;
	}

	val = input.value;

	return val !== '' && val !== false && val !== null
		&& (!Array.isArray(val) || !!val.length)
		&& (!window.FileList || !(val instanceof window.FileList) || val.length);
};


// override NetteForms methods
netteForms.showFormErrors = (form, errors, focus) => {
	if (!form.classList.contains('live-validation')) {
		// add keyup event
		form.addEventListener('keyup', debounce((event) => {
			const target = event.target;
			if (target.form && !target.parentElement.classList.contains('fn_checkbox-collapse') && !target.parentElement.classList.contains('fn_checkTab')) {
				netteForms.validateForm(target, false, false);
			}
		}), 800);

		form.addEventListener('change', debounce((event) => {
			const target = event.target;
			if (target.form && !target.parentElement.classList.contains('fn_checkbox-collapse') && !target.parentElement.classList.contains('fn_checkTab')) {
				netteForms.validateForm(target, false, false);
			}
		}), 100);

		form.classList.add('live-validation');
	}

	netteForms.clearErrors(form);

	let elFocus;

	let groupCheckboxes = form.hasAttribute('data-form-group-checkboxes');
	let showedErrors = [];

	errors.forEach((error) => {
		const elem = error.element;
		const message = error.message;

		let showError = true;
		if (groupCheckboxes) {
			if (elem.type === 'checkbox') {
				if (showedErrors.includes(elem.getAttribute('name'))) {
					showError = false;
				} else {
					showedErrors.push(elem.getAttribute('name'));
				}
			}
		}

		if (showError === false) {
			return;
		}

		if (!elFocus && elem.focus) {
			elFocus = elem;
		}

		netteForms.showElemError(elem, message);
	});

	// focus to first error
	if (elFocus && focus) {
		elFocus.focus();
		try {
			elFocus.scrollIntoView({block: 'center'});
		} catch (e) {
			console.error(e.error);
		}
	}
};

netteForms.showElemError = (elem, message) => {
	elem.classList.remove("is-valid");
	elem.classList.add('is-invalid');
	if (message.length) {
		elem.insertAdjacentHTML('afterend', '<div data-feedback-for="' + elem.id  + '" class="invalid-feedback">' + message + '</div>');
	}
};

netteForms.clearElemError = (elem, validate = true) => {
	elem.classList.remove("is-invalid");
	if (validate) {
		elem.classList.add('is-valid');
	}
	const feedback = document.querySelector(`[data-feedback-for="${elem.id}"]`);
	if (feedback) {
		feedback.remove();
	}
};

netteForms.clearErrors = (form) => {
	const invalidItems = form.querySelectorAll('.is-invalid');
	invalidItems.forEach((invalidItem) => {
		netteForms.clearElemError(invalidItem);
	});
};

netteForms.validateForm = (sender, onlyCheck, focus) => {
	const form = sender.form || sender;
	let scope = false;

	netteForms.formErrors = [];

	if (form['nette-submittedBy'] && form['nette-submittedBy'].getAttribute('formnovalidate') !== null) {
		const scopeArr = JSON.parse(form['nette-submittedBy'].getAttribute('data-nette-validation-scope'));
		if (scopeArr !== null && scopeArr.length) {
			scope = new RegExp('^(' + scopeArr.join('-|') + '-)');
		} else {
			netteForms.showFormErrors(form, []);
			return true;
		}
	}

	let radios = {}, i, elem;

	for (i = 0; i < form.elements.length; i++) {
		elem = form.elements[i];

		if (elem.tagName && !(elem.tagName.toLowerCase() in {input: 1, select: 1, textarea: 1, button: 1})) {
			continue;

		} else if (elem.type === 'radio') {
			if (radios[elem.name]) {
				continue;
			}
			radios[elem.name] = true;
		}

		if ((scope && !elem.name.replace(/]\[|\[|]|$/g, '-').match(scope)) || netteForms.isDisabled(elem)) {
			continue;
		}

		if (!netteForms.validateControl(elem, null, onlyCheck) && !netteForms.formErrors.length) {
			return false;
		}
	}

	if(focus === undefined) {
		focus = true;
	}

	netteForms.showFormErrors(form, netteForms.formErrors, focus);

	return !netteForms.formErrors.length;
};

class NetteFormsExtension {
	constructor(naja) {
		naja.addEventListener('init', () => {
			document.body.addEventListener('click', function(e) {
				var target = e.target;
				while (target) {
					if (target.form && target.type in {submit: 1, image: 1}) {
						target.form['nette-submittedBy'] = target;
						break;
					}
					target = target.parentNode;
				}
			});
		});
	}
}

naja.registerExtension(NetteFormsExtension);